import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  saveEmailId,
  postInformationToDiscord,
  postSummaryToDiscord,
} from "../../action/HomePage.action";
import FooterInfo from "./FooterInfo";
import FooterLinks from "./FooterLinks";
import FooterNewsletter from "./FooterNewsletter";
import SubscribePopup from "./SubscribePopup";
import "./footer.css";

const Footer = () => {
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();

  const handleNewsletterSubmit = (email) => {
    dispatch(saveEmailId(email));
    dispatch(postInformationToDiscord(email));
    postSummaryToDiscord(email);
    setShowPopup(true);
  };

  return (
    <>
      <footer id="footer">
        <div className="footer-top">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <FooterInfo />
              </div>

              <div className="col-lg-3 col-md-6 footer-links mt-1">
                <h4>Company</h4>
                <FooterLinks
                  links={[
                    { to: "/lab-for-college", label: "Smart Learning" },
                    {
                      to: "/smart-manufacturing",
                      label: "Smart Manufacturing",
                    },
                    { to: "/contact", label: "Contact Us" },
                  ]}
                />
              </div>

              <div className="col-lg-3 col-md-6 footer-links mt-1">
                <h4>Quick Links</h4>
                <FooterLinks
                  links={[
                    {
                      to: "/smart-manufacturing",
                      label: "Smart Manufacturing",
                    },
                    {
                      to: "/lab-for-college",
                      label: "Lab for College / University",
                    },
                    { to: "/lab-for-school", label: "Lab for 6th-12th Grade" },
                  ]}
                />
              </div>

              <div className="col-lg-3 col-md-6 footer-newsletter mt-1">
                <FooterNewsletter onSubmit={handleNewsletterSubmit} />
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>Terafac</span>
            </strong>
            . All Rights Reserved
          </div>
        </div>
      </footer>
      {showPopup && <SubscribePopup onClose={() => setShowPopup(false)} />}
    </>
  );
};

export default Footer;
